module.exports = __webpack_public_path__ + "img/group_scenario_icon.deeb1892.svg";